import { render } from "./tiposopera-table.vue?vue&type=template&id=d6f3e4c8"
import script from "./tiposopera-table.vue?vue&type=script&lang=js"
export * from "./tiposopera-table.vue?vue&type=script&lang=js"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__